import React from 'react';
import styled from 'styled-components';
import { ReactComponent as SilhouetteIcon } from '../../assets/icons/account.svg';
import { utils } from 'kb-shared';

const { ROLES_TO_PATIENT_LANGUAGE } = utils;

interface Props {
  name: string;
  role: string;
}

const ProviderIntro = ({ name, role }: Props) => {
  // @ts-ignore
  const roleString = ROLES_TO_PATIENT_LANGUAGE[role] || `a ${role.replace('_', ' ')}`;
  return (
    <Container>
      <Bubble>
        <SilhouetteIcon />
        <span>
          <strong>{name}</strong> is {roleString} on your care team.
        </span>
      </Bubble>
    </Container>
  );
};

export default ProviderIntro;

const Container = styled.div`
  text-align: center;
  margin: 1.5em;
  @media (min-width: ${({ theme }) => theme.breakpoints.largePhonePortrait}) {
    margin: 2em;
  }
  font-size: smaller;
`;

const Bubble = styled.li`
  ${({ theme }) => theme.fonts.FoundersGrotesk};
  background-color: ${({ theme }) => theme.colors.beigeLight};
  padding: 1em;
  border-radius: 15px;
  width: fit-content;
  white-space: pre-wrap;
  margin: 0 auto;
  display: flex;
  align-items: center;

  strong {
    margin-left: 5px;
  }

  svg {
    height: 1em;
  }
`;
